<div class="export-modal">
  <div class="modal-header">
    <div class="export-modal-header">
      <h5>{{translate?.report.sections.sec8.singular}}</h5>
    </div>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left"
      (click)="modalRef.hide()"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  <form>
    <div class="modal-body pt-0">
      <form [formGroup]="scheduleConfigForm">
        <!-- 1: SELECT FILE TYPE -->
        <section class="section">
          <div class="section__title">
            <div class="header-title">
              <span>
                <i class="fa-solid fa-circle-1 fa-lg"></i>
              </span>
              <div class="title mandatory">
                {{ translate?.report.messages.selectFileType }}
              </div>
            </div>
            <div class="sub">
              {{ translate?.report.messages.selectTypeOfFile }}
              {{ translate?.report.label.singular }}
              {{ translate?.report.messages.toBeSentIn }}
            </div>
          </div>
          <div class="filetype">
            <!-- CSV -->
            <div class="filetype__option">
              <input
                type="radio"
                id="ex-csv"
                value="CSV"
                formControlName="fileType"
                checked
              />
              <label for="ex-csv" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i
                    class="filetype__icon fa fa-file-text-o"
                    aria-hidden="true"
                  ></i>
                  <span class="filetype__title">{{
                    translate?.report.fields.csv.singular
                  }}</span>
                </div>
                <span class="filetype__desc"
                  >{{ translate?.report.messages.csvDescription }}.</span
                >
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>
            <!-- Excel -->
            <div class="filetype__option">
              <input
                type="radio"
                id="ex-xls"
                value="EXCEL"
                formControlName="fileType"
              />
              <label for="ex-xls" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i
                    class="filetype__icon fa fa-file-excel-o"
                    aria-hidden="true"
                  ></i>
                  <span class="filetype__title">{{
                    translate?.report.fields.excel.singular
                  }}</span>
                </div>
                <span class="filetype__desc"
                  >{{ translate?.report.messages.excelDescription }}.</span
                >
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>
            <!-- PDF -->
            <div class="filetype__option">
              <input
                type="radio"
                id="ex-pdf"
                value="PDF"
                formControlName="fileType"
              />
              <label for="ex-pdf" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i
                    class="filetype__icon fa fa-file-pdf-o"
                    aria-hidden="true"
                  ></i>
                  <span class="filetype__title">{{
                    translate?.report.fields.pdf.singular
                  }}</span>
                </div>
                <span class="filetype__desc"
                  >{{ translate?.report.messages.pdfDescription }}.</span
                >
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>
          </div>
          <div class="p-error text-10 mt-10px" *ngIf="!scheduleConfigForm.controls['fileType'].value && isSubmitClicked">
            <span>{{translate?.report.validationFE.pleaseSelectFileType}}.</span>
          </div>
        </section>
        <!-- 2: SCHEDULE DURATION -->
        <section class="section">
          <div class="section__title">
            <div class="header-title">
              <span>
                <i class="fa-solid fa-circle-2 fa-lg"></i>
              </span>
              <div class="title mandatory">
                {{ translate?.report.messages.scheduleDuration }}
              </div>
            </div>
            <div class="sub">
              {{ translate?.report.messages.setDurtaionScheduleValid }}
            </div>
          </div>
          <div class="row-gap">
            <div class="mp-inline-row">
              <span class="field-label">{{
                translate?.report.messages.scheduleStartsFrom
              }}</span>
              <div>
                <p-calendar [placeholder]="translate?.report.messages.selectStartDate+'...'" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="onStartDateSelect()" formControlName="scheduleStartDate" [minDate]="minDateStart" appendTo="body"  styleClass="cal-btn"></p-calendar>
                <div class="p-error text-10" *ngIf="scheduleConfigForm.controls['scheduleStartDate'].touched && scheduleConfigForm.controls['scheduleStartDate'].invalid">
                  <span *ngIf="scheduleConfigForm.controls['scheduleStartDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
              </div>
              <span class="field-label">&nbsp;{{translate?.report.messages.andEnds}}&nbsp;</span>
              <p-calendar [placeholder]="translate?.report.messages.selectEndDate+'...'" dateFormat="dd/mm/yy" styleClass="cal-btn"
                [showIcon]="true" 
                [minDate]="minDate" formControlName="scheduleEndDate" 
                (onSelect)="onEndDateSelect()" (onInput)="onEndDateSelect()" appendTo="body">
              </p-calendar>
              <span class="mx-2 font-bold">OR</span>
              <span>
                <p-checkbox (onChange)="onNeverCheckboxChange()"
                  binary="true"
                  formControlName="isScheduleNeverEnd"
                ></p-checkbox>
                <label class="field-label ms-2" for="never">{{
                  translate?.report.messages.never
                }}</label>
              </span>
            </div>
              <div
                class="p-error text-10"
                *ngIf="
                  !scheduleConfigForm.controls['isScheduleNeverEnd'].value &&
                  !scheduleConfigForm.controls['scheduleEndDate'].value &&
                  isSubmitClicked
                "
              >
                <span
                  >{{translate?.report.validationFE.selectEndDateOrNever}}</span
                >
              </div>
          </div>
        </section>
        <!-- 3: WHEN SHOULD THIS REPORT BE CREATED -->
        <section class="section">
          <div class="section__title">
            <div class="header-title">
              <span>
                <i class="fa-solid fa-circle-3 fa-lg"></i>
              </span>
              <div class="title mandatory">
                {{ translate?.report.messages.whenShouldThisRecordCreated }}
              </div>
            </div>
            <div class="sub">
              {{ translate?.report.messages.setWhenThis }}
              {{ translate?.report.label.singular }}
              {{ translate?.report.messages.willBeScheduledToBeSent }}.
              <span class="d-block text-12">
                {{translate?.requisition.fields.note.singular}}: {{translate?.report.messages.editingFieldsInSection}}
                {{translate?.report.label.singular}} {{translate?.report.messages.onlyBeingSentOut}}
              </span>
            </div>
          </div>
          <div class="row-gap">
            <div class="mp-inline-row">
              <span class="field-label"
                >{{ translate?.report.messages.scheduleSentOut }}
              </span>
              <!-- <span class="field-label">At</span> /--THIS IS FOR WHEN USER CHOOSES DAILY SCHEDULE-/ -->
              <div>
                <p-dropdown
                  class="w-200px d-block"
                  [options]="frequencyList"
                  [showClear]="true"
                  [placeholder]="translate?.report.messages.selectAFrequency + '...'"
                  optionLabel="name"
                  (onChange)="onFrequencyChange($event)"
                  optionValue="value"
                  formControlName="frequency"
                ></p-dropdown>
                <div
                  class="p-error text-10"
                  *ngIf="
                    scheduleConfigForm.controls['frequency'].touched &&
                    scheduleConfigForm.controls['frequency'].invalid
                  "
                >
                  <span
                    *ngIf="
                      scheduleConfigForm.controls['frequency'].errors?.required
                    "
                    >{{ translate?.general.validationFE.requiredField }}</span
                  >
                </div>
              </div>
            </div>
            <div
              class="mp-inline-row"
              *ngIf="scheduleConfigForm.get('frequency').value"
            >
              <ng-container
                *ngIf="scheduleConfigForm.get('frequency').value == 'WEEKLY'"
              >
                <span class="field-label"
                  >{{ translate?.report.messages.onUpper }}&nbsp;</span
                >
                <div>
                  <p-dropdown
                    class="w-200px d-block"
                    [options]="dayList"
                    [showClear]="true"
                    optionLabel="name"
                    optionValue="value"
                    [placeholder]="translate?.report.messages.selectADay + '...'"
                    formControlName="day"
                  ></p-dropdown>
                  <div
                    class="p-error text-10"
                    *ngIf="
                      scheduleConfigForm.controls['day'].touched &&
                      scheduleConfigForm.controls['day'].invalid
                    "
                  >
                    <span
                      *ngIf="
                        scheduleConfigForm.controls['day'].errors?.required
                      "
                    >
                      {{ translate?.general.validationFE.requiredField }}
                    </span>
                  </div>
                </div>
                <!--//THIS IS FOR DAYS IN THE WEEK/ -->
              </ng-container>
              <ng-container
                *ngIf="
                  scheduleConfigForm.get('frequency').value == 'DAILY' ||
                  scheduleConfigForm.get('frequency').value == 'WEEKLY'
                "
              >
                <span class="field-label"
                  >&nbsp;{{ translate?.report.messages.atLower }}&nbsp;</span
                >
                <div>
                  <p-dropdown
                    class="w-200px d-block"
                    formControlName="time"
                    optionLabel="name"
                    optionValue="value"
                    [options]="timeList"
                    [showClear]="true"
                    [placeholder]="translate?.report.messages.selectATime + '...'"
                  ></p-dropdown>
                  <div
                    class="p-error text-10"
                    [ngClass]="{
                      weeklyAt:
                        scheduleConfigForm.controls['frequency'].value ==
                        'WEEKLY'
                    }"
                    *ngIf="
                      scheduleConfigForm.controls['time'].touched &&
                      scheduleConfigForm.controls['time'].invalid
                    "
                  >
                    <span
                      *ngIf="
                        scheduleConfigForm.controls['time'].errors?.required
                      "
                    >
                      {{ translate?.general.validationFE.requiredField }}
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="scheduleConfigForm.get('frequency').value == 'MONTHLY'"
              >
                <span class="field-label"
                  >&nbsp;{{ translate?.report.messages.onThe }}&nbsp;</span
                >
                <div>
                  <p-dropdown
                    class="w-200px d-block"
                    formControlName="dayOfMonth"
                    [options]="dayOfMonthList"
                    [showClear]="true"
                    optionLabel="name"
                    optionValue="value"
                    [placeholder]="translate?.report.messages.selectATime + '...'"
                  ></p-dropdown>
                  <div
                    class="p-error text-10"
                    *ngIf="
                      scheduleConfigForm.controls['dayOfMonth'].touched &&
                      scheduleConfigForm.controls['dayOfMonth'].invalid
                    "
                  >
                    <span
                      *ngIf="
                        scheduleConfigForm.controls['dayOfMonth'].errors
                          ?.required
                      "
                    >
                      {{ translate?.general.validationFE.requiredField }}
                    </span>
                  </div>
                </div>
                <div>
                  <p-dropdown
                    class="w-200px d-block"
                    formControlName="dayMonth"
                    [options]="dayList"
                    [showClear]="true"
                    optionLabel="name"
                    optionValue="value"
                   [placeholder]="translate?.report.messages.selectADay + '...'"
                  ></p-dropdown>
                  <div
                    class="p-error text-10"
                    *ngIf="
                      scheduleConfigForm.controls['dayMonth'].touched &&
                      scheduleConfigForm.controls['dayMonth'].invalid
                    "
                  >
                    <span
                      *ngIf="
                        scheduleConfigForm.controls['dayMonth'].errors?.required
                      "
                    >
                      {{ translate?.general.validationFE.requiredField }}
                    </span>
                  </div>
                </div>
                <span class="field-label">&nbsp;{{translate?.report.messages.ofTheMonth}} {{translate?.report.messages.atLower}}</span>
                <div>
                  <p-dropdown class="w-200px" formControlName="time" optionLabel="name" optionValue="value" [options]="timeList" [showClear]="true" placeholder="Select a Time"></p-dropdown>
                  <div class="p-error text-10"*ngIf="scheduleConfigForm.controls['time'].touched && scheduleConfigForm.controls['time'].invalid">
                    <span *ngIf="scheduleConfigForm.controls['time'].errors?.required">
                      {{translate?.general.validationFE.requiredField}}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>
        <!-- 4: SELECT EMAIL RECIPIENTS -->
        <section class="section">
          <div class="section__title">
            <div class="header-title">
              <span>
                <i class="fa-solid fa-circle-4 fa-lg"></i>
              </span>
              <div class="title mandatory">
                {{ translate?.report.messages.selectEmailRecipient }}
              </div>
            </div>
            <div class="sub">
              {{ translate?.report.messages.selectRecipientsAtLeastOne }}
            </div>
          </div>
          <div class="grid-2">
            <div>
              <label class="field-label">{{
                translate?.setup.users.users.label.plural
              }}</label>
              <div>
                <p-multiSelect
                  optionLabel="fullName"
                  optionValue="id"
                  [filter]="true"
                  [options]="users"
                  class="w-100 reports-select"
                  [showToggleAll]="false"
                  display="chip"
                  formControlName="recipientsUser"
                  (onChange)="onUsersChange()"
                  [placeholder]="translate?.report.messages.selectUser + '...'"
                  [panelStyle]="{ 'min-height': '380px' }"
                ></p-multiSelect>
                <div
                  class="p-error text-10"
                  *ngIf="
                    scheduleConfigForm.controls['recipientsUser'].touched &&
                    scheduleConfigForm.controls['recipientsUser'].invalid
                  "
                >
                  <span>
                    {{ translate?.report.validationFE.atLeastOneIsRequired }}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <label class="field-label">{{
                translate?.setup.users.groups.label.plural
              }}</label>
              <div>
                <p-multiSelect
                  optionLabel="name"
                  optionValue="id"
                  [filter]="true"
                  [options]="user_groups"
                  formControlName="recipientsGroup"
                  class="w-100 reports-select"
                  [showToggleAll]="false"
                  display="chip"
                  (onChange)="onGroupChange()"
                  [placeholder]="translate?.report.messages.selectGroup+'...'"
                  [panelStyle]="{ 'min-height': '380px' }"
                ></p-multiSelect>
                <div
                  class="p-error text-10"
                  *ngIf="
                    scheduleConfigForm.controls['recipientsGroup'].touched &&
                    scheduleConfigForm.controls['recipientsGroup'].invalid
                  "
                >
                  <span>
                    {{ translate?.report.validationFE.atLeastOneIsRequired }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-2">
            <div>
              <label class="field-label">{{
                translate?.setup.users.users.fields.email.singular
              }}</label>
              <p-chips
                formControlName="otherRecipients"
                (onAdd)="onEmailAdd()"
                [placeholder]="
                  translate?.report.messages.enterEmailAddresses+'...'"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    scheduleConfigForm.controls['otherRecipients']?.touched &&
                    scheduleConfigForm.controls['otherRecipients'].invalid
                }"
              ></p-chips>
              <div
                class="p-error text-10"
                *ngIf="
                  scheduleConfigForm.controls['otherRecipients']?.touched &&
                  scheduleConfigForm.controls['otherRecipients'].invalid
                "
              >
                <span
                  *ngIf="
                    scheduleConfigForm.controls['otherRecipients']?.errors
                      ?.validEmailError
                  "
                  id="label_JobOwnerReqField"
                  >{{ translate?.general.validationFE.invalidEmailFormat }}
                </span>
                 <span *ngIf="
                    scheduleConfigForm.controls['otherRecipients']?.errors
                      ?.required
                  "
                  id="label_JobOwnerReqField">
                    {{ translate?.report.validationFE.atLeastOneIsRequired }}
                  </span>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="custella-btn-white"
        (click)="modalRef.hide()"
      >
        {{ translate?.general.buttons.cancel.singular }}
      </button>
      <p-button
        *ngIf="data.access != 'VIEWER'"
        [label]="data.mode == 'edit' ? translate?.general.buttons.save.singular : translate?.general.buttons.proceed.singular"
        (onClick)="onFormSubmit()"
        [disabled]="scheduleConfigForm.invalid"
        styleClass="h-32"
      ></p-button>
      <!---->
    </div>
  </form>
</div>